import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ToastMessage {
  id: string;
  type: 'success' | 'error' | 'warning' | 'info';
  title: string;
  message: string;
  duration: number;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private toastSubject = new Subject<ToastMessage>();
  public toast$ = this.toastSubject.asObservable();

  show(title: string, message: string, type: 'success' | 'error' | 'warning' | 'info' = 'info', duration: number = 3000): void {
    const toast: ToastMessage = {
      id: this.generateId(),
      type,
      title,
      message,
      duration
    };
    this.toastSubject.next(toast);
  }

  success(title: string, message: string, duration?: number): void {
    this.show(title, message, 'success', duration);
  }

  error(title: string, message: string, duration?: number): void {
    this.show(title, message, 'error', duration);
  }

  warning(title: string, message: string, duration?: number): void {
    this.show(title, message, 'warning', duration);
  }

  info(title: string, message: string, duration?: number): void {
    this.show(title, message, 'info', duration);
  }

  private generateId(): string {
    return `toast-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  }
}
